import { render, staticRenderFns } from "./Shopping.vue?vue&type=template&id=17e38da3&scoped=true"
import script from "./Shopping.vue?vue&type=script&lang=js"
export * from "./Shopping.vue?vue&type=script&lang=js"
import style0 from "./Shopping.vue?vue&type=style&index=0&id=17e38da3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e38da3",
  null
  
)

export default component.exports